__turbopack_context__.v({
  "badges": "ConnectionAppCell-module__dfhWOa__badges",
  "badgesOverflow": "ConnectionAppCell-module__dfhWOa__badgesOverflow",
  "root": "ConnectionAppCell-module__dfhWOa__root",
  "version": "ConnectionAppCell-module__dfhWOa__version",
});
